import { render } from "./AddStock.vue?vue&type=template&id=768d368e&scoped=true"
import script from "./AddStock.vue?vue&type=script&lang=js"
export * from "./AddStock.vue?vue&type=script&lang=js"

import "./AddStock.vue?vue&type=style&index=0&id=768d368e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768d368e"]])

export default __exports__